import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ExporListService } from 'src/app/_service/exporList.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material';
import { TreeComponent } from 'src/app/tree/tree.component';
import { AuthService } from 'src/app/_service/auth.service';

@Component({
  selector: 'app-exportList',
  templateUrl: './exportList.component.html',
  styleUrls: ['./exportList.component.css']
})
export class ExportListComponent implements OnInit {

  constructor(private exportListService: ExporListService,
    private alertify: AlertifyService,
    private authService: AuthService,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public passedData: any
    ) {}

    productId = this.passedData.productId;
    // single location
    // singleLocation = this.passedData.locations.childAuthorityUnitId;

    // singleAuthority = this.passedData.locations.checklistSelection._selection; // iterable
    selectedLocations = this.passedData.locations;
    // parent + decendants
    // subParentAndChildren = this.passedData.locations.checklistSelection._selected; // iterable

    allExportLists: any = [];

  productName;
  productNameChecked = false;

  productCode;
  productCodeChecked = false;

  revisionDate;
  revisionDateChecked = false;

  lastVerifiedDate;
  lastVerifiedDateChecked = false;

  hazardClassification;
  hazardClassificationChecked = false;

  manufacturerName;
  manufacturerNameChecked = false;

  locationDepartment;
  locationDepartmentChecked = false;

  site;
  siteChecked = false;

  isLoading = false;

  loading = false;

  isModified = false;

  generateModel: any = {};

  sdsUserId: any;
  sdsUserIdNumber: number;

  selectionRequired: any = {};

  ngOnInit() {
    this.productNameChecked = true;
    this.productCodeChecked = true;
    this.manufacturerNameChecked = true;
    this.revisionDateChecked = true;
    this.lastVerifiedDateChecked = true;
    this.hazardClassificationChecked = true;
    this.siteChecked = true;
    this.locationDepartmentChecked = true;

    console.log(this.passedData);

    this.sdsUserId = this.authService.decodedToken.userid;
    this.sdsUserIdNumber = +this.sdsUserId;

    this.hideLocationCheckBox();
  }


  onProductNameChecked() {
    this.productName = '';
    if (this.productNameChecked) {
      this.productName = 'ProductName';
    }
  }

  onProductCodeChecked() {
    this.productCode = '';
    if (this.productCodeChecked) {
      this.productCode = 'ProductCode';
    }
  }

  onManufacturerNameChecked() {
    this.manufacturerName = '';
    if (this.manufacturerNameChecked) {
      this.manufacturerName = 'Manufacturer';
    }
  }

  onRevisionDateChecked() {
    this.revisionDate = '';
    if (this.revisionDateChecked) {
      this.revisionDate = 'RevisionDate';
    }
  }

  onLastVerifiedChecked() {
    this.lastVerifiedDate = '';
    if (this.lastVerifiedDateChecked) {
      this.lastVerifiedDate = 'LastVerified';
    }
  }

  onHazardClassificationChecked() {
    this.hazardClassification = '';
    if (this.hazardClassificationChecked) {
      this.hazardClassification = 'HazardClassification';
    }
  }

  onSiteChecked() {
    this.site = '';
    if (this.siteChecked) {
      this.site = 'Site';
    }
  }

  onLocationDepartmentChecked() {
    this.locationDepartment = '';
    if (this.locationDepartmentChecked) {
      this.locationDepartment = 'LocationDepartment';
    }
  }

  // hides site and location > department check boxes
  // if location tree is not selected
  hideLocationCheckBox() {
    if (this.selectedLocations.size > 0) {
      return true;
    } else {
      this.siteChecked = false;
      this.locationDepartmentChecked = false;
      return false;
    }
  }

  exportProductList() {
    this.isLoading = true;
    this.loading = true;

    const params = new URLSearchParams();
    if (this.productNameChecked) {
      this.onProductNameChecked();
      params.append('selection', this.productName);
    }

    if (this.productCodeChecked) {
      this.onProductCodeChecked();
      params.append('selection', this.productCode);
    }
    if (this.manufacturerNameChecked) {
      this.onManufacturerNameChecked();
      params.append('selection', this.manufacturerName);
    }
    if (this.revisionDateChecked) {
      this.onRevisionDateChecked();
      params.append('selection', this.revisionDate);
    }
    if (this.lastVerifiedDateChecked) {
      this.onLastVerifiedChecked();
      params.append('selection', this.lastVerifiedDate);
    }
    if (this.hazardClassificationChecked) {
      this.onHazardClassificationChecked();
      params.append('selection', this.hazardClassification);
    }

    if (this.siteChecked) {
      this.onSiteChecked();
      params.append('selection', this.site);
    }

    if (this.locationDepartmentChecked) {
      this.onLocationDepartmentChecked();
      params.append('selection', this.locationDepartment);
    }

    for (const product of this.productId) {
      params.append('productId', product.productId);
    }

      // super admin location tree/location ID
      if (this.authService.decodedToken.role === 'Super Admin') {
        this.generateModel.LocationId = [];
        for (const loc of this.selectedLocations) {
            this.generateModel.LocationId.push(loc.authorityUnitId);
        }
      }
  
      if (this.authService.decodedToken.role === 'Site Admin') {
        this.generateModel.LocationId = [];
        for (const loc of this.selectedLocations) {
          if (loc.userId === this.sdsUserIdNumber) {
            this.generateModel.LocationId.push(loc.authorityUnitId);
          }
        }
      }

    this.exportListService.getExportList(params, this.generateModel).subscribe(res  => {
      this.selectionRequired = res.headers.get('locationsNotSelected');
      if (this.selectionRequired) {
        this.alertify.message(this.selectionRequired);
        this.isModified = true;
        this.isLoading = false;
        this.loading = false;
      } else {
        if (res) {
          const link = document.createElement('a');
          if (window.navigator &&
            window.navigator.msSaveOrOpenBlob) { // for IE
            window.navigator.msSaveOrOpenBlob(res.body, 'Export' + `.xlsx`);
            this.isModified = true;
            this.isLoading = false;
            this.loading = false;
            this.alertify.message('Export generation is complete');
          } else {
          link.href = window.URL.createObjectURL(res.body);
          link.download = 'Export';
          link.click();
          this.isModified = true;
          this.isLoading = false;
          this.loading = false;
          this.alertify.message('Export generation is complete');
        }
        }
      }
  }, error => {
    this.isModified = true;
    this.loading = false;
    this.isLoading = false;
    this.alertify.error('Something went wrong, please try again.');
  }
  );
  }
}

export interface ExportListFields {
  productNames: string;
  productCodes:  string;
}